module.exports = {
  "tri-0140": {
    "identifierType": "PORTAL_ID",
    "maxAge": 86400000,
    "parameters": {
      "group": [
        "control",
        "variation"
      ]
    }
  },
  "ppia-0003": {
    "identifierType": "PORTAL_ID",
    "maxAge": 86400000,
    "parameters": {
      "group": [
        "control",
        "variationA",
        "variationB",
        "variationC"
      ]
    }
  },
  "ubx-0001": {
    "identifierType": "OTHER",
    "maxAge": 86400000,
    "parameters": {
      "group": [
        "control",
        "variation",
        "variation_b"
      ]
    }
  },
  "ppfe-0008": {
    "identifierType": "PORTAL_ID",
    "maxAge": 86400000,
    "parameters": {
      "group": [
        "control",
        "variation"
      ]
    }
  },
  "ppfe-0010": {
    "identifierType": "PORTAL_ID",
    "maxAge": 86400000,
    "parameters": {
      "group": [
        "control",
        "variation"
      ]
    }
  },
  "ppfe-0011": {
    "identifierType": "PORTAL_ID",
    "maxAge": 86400000,
    "parameters": {
      "group": [
        "control",
        "variation"
      ]
    }
  }
};